import { useEffect, useState } from 'react';
import { ReactComponent as CloseSvg } from '../../assets/svg/closeCircle.svg';
import request from '../../lib/request';
import Message from './message';

const Dialog = ({
  dialogRef,
  closeDialog,
  message,
  getMessage,
  isDialogOpen,
  user,
}) => {
  const [tab, setTab] = useState('MESSAGE');

  useEffect(() => {
    if (isDialogOpen) {
      markAllMessageAsRead();
    }
  }, [isDialogOpen]);

  const markAllMessageAsRead = async () => {
    try {
      if (
        message?.list?.some((msg) => {
          return msg.from === 'COACH' && !msg.readAt;
        })
      ) {
        await request.put(`/message?mark=read`);
      }
    } catch (error) {
      console.error('Error marking all as read:', error);
    }
  };

  const handleTabChange = (tab) => () => {
    setTab(tab);
  };

  return (
    <dialog
      ref={dialogRef}
      className='w-full h-full max-w-lg max-h-dvh p-4'
    >
      <div className='flex justify-end'>
        <button onClick={closeDialog}>
          <CloseSvg />
        </button>
      </div>
      <ul className='flex justify-center items-center gap-8 mb-6'>
        <li className={`relative cursor-pointer border-black font-bold`}>
          Messages
        </li>
      </ul>
      {tab === 'MESSAGE' && (
        <Message
          message={message}
          user={user}
          getMessage={getMessage}
        />
      )}
    </dialog>
  );
};

export default Dialog;
